// @flow

// These keys are the subject for implicit translation. Wrapping with t() for i18next-scanner.
const t = x => x;

export default {
  presence: t('Please fill in this field, it is required'),
};
